import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';

const EditBoothCategory = (props) => {
    const history = useHistory();
    const id = props.match.params.id
    const [disabled, setdisabled] = useState(false);
    const [errorlist, setError] = useState([]);
    const [exBoothCategoryEdit, setExBoothCategoryEdit] = useState({
        title: "",
        size: "",
        description: "",
        error_list: [],
    });
    useEffect(() => {
        axios.get(`api/edit-exhibition-booth-category/${id}`).then(res => {
            if (res.status == 200) {
                const editData = res.data.exBcEdit;
                setExBoothCategoryEdit(editData);
            }
        });
    }, [props.match.params.id]);
    const handleInput = (e) => {
        e.persist();
        setExBoothCategoryEdit({ ...exBoothCategoryEdit, [e.target.name]: e.target.value });
    }
    const exBoothCatUpdate = (e) => {
        e.preventDefault();
        const data = {
            title: exBoothCategoryEdit.title,
            size: exBoothCategoryEdit.size,
            description: exBoothCategoryEdit.description,
        }
        setdisabled(true);
        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            //id from props
            axios.post(`/api/update-exhibition-booth-category/${id}`, data, config).then(res => {
                if (res.data.status === 200) {
                    swal('Success', res.data.message, 'success');
                    history.push('/admin/exhibition/boothcategory');
                }
                else {
                    swal("Review Status Field Is Requried !!", "", "error");
                }
            });


        });

    }


    return (
        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                <h4 sx={{ m: 2, color: '#000000' }} >
                    <Button sx={{
                        float: 'right',
                        marginTop: '2%',
                        ":hover": {
                            color: "white"
                        }
                    }}
                        color='success'
                        size='small'
                        variant='contained'
                        onClick={() => history.goBack()}  >
                        BAck
                    </Button>
                </h4>
                <Card sx={{ width: '60vw', float: 'center' }} >
                    <CardContent >
                        <Typography component="h1" variant="h5">
                            Update Exhibition Booth category {id}
                        </Typography>
                        <Box component="form" onSubmit={exBoothCatUpdate} noValidate sx={{ mt: 3 }}>
                            <Grid container spacing={4}>

                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Title"
                                        autoFocus
                                        name='title' onChange={handleInput}
                                        value={exBoothCategoryEdit.title || ""}
                                    />
                                </Grid>

                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Size"
                                        autoFocus
                                        name='size' onChange={handleInput}
                                        value={exBoothCategoryEdit.size || ""}
                                    />
                                </Grid>
                                <Grid item xs={6} >

                                </Grid>
                                <Grid item xs={12} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Add Descriptions"
                                        autoFocus
                                        name='description' onChange={handleInput}
                                        value={exBoothCategoryEdit.description || ""}
                                        multiline
                                        rows={6}
                                    />

                                </Grid>
                            </Grid>

                            <Grid container justifyContent="flex-end">
                                <Button
                                    disabled={disabled}
                                    type="submit"
                                    // fullWidth
                                    variant="contained"
                                    sx={{ mt: 5,backgroundColor: '#145348' }} >
                                    Submit
                                </Button>
                            </Grid>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </div>
    );
}

export default EditBoothCategory;
